export default __webpack_public_path__ + "static/media/navigation-Header-4k.08bff25a.jpg";